import { mockAdapter } from './mockAdapter'

export const expectHistoryUrl = (
  method: 'get' | 'post' | 'delete' | 'put',
  url: string
) => {
  return expect(
    mockAdapter.history[method].find((history) =>
      new RegExp(url).test(history.url)
    )
  )
}
